export enum LoanApplicationDocumentType {
    PHOTO = 'photo',
    PAN = 'pan',
    ADDRESS_PROOF = 'address_proof',
    BANK_STATEMENT = 'bank',
    ITR = 'itr',
    SALARY_SLIP = 'salary',
    OTHER_DOCUMENT = 'other_document',
    AADHAAR = 'aadhaar',
    PASSPORT = 'passport',
    DRIVING_LICENSE = 'driving',
    VOTER_ID = 'voter',
    ELECTRICITY = 'electricity',
    TELEPHONE = 'telephone',
    LPG = 'lpg'
}

export class LoanApplicationDocumentTypeModel {
    static getPrintableNameFor(key: LoanApplicationDocumentType | string): string {
        switch (key) {
            case LoanApplicationDocumentType.PHOTO:
                return 'photo';
            case LoanApplicationDocumentType.PAN:
                return 'pan';
            case LoanApplicationDocumentType.ADDRESS_PROOF:
                return 'address proof';
            case LoanApplicationDocumentType.BANK_STATEMENT:
                return 'bank statement';
            case LoanApplicationDocumentType.ITR:
                return 'ITR document';
            case LoanApplicationDocumentType.SALARY_SLIP:
                return 'salary slip';
            case LoanApplicationDocumentType.OTHER_DOCUMENT:
                return 'other document';
        }
    }
}
